exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TRouteMeta-ab9011f9{font-weight:500;font-size:13px;line-height:14px;padding:15px 0 3px 0;display:flex;flex-wrap:wrap}.TRouteMetaItem-91b0bcf4{flex:1 1 50%;cursor:default;color:#616161;position:relative;margin-bottom:10px}.TRouteMetaItem-91b0bcf4.clickable-8d193461{cursor:pointer}.TRouteMetaItem-91b0bcf4 .container-c8a4422f{display:inline-block}.TRouteMetaItem-91b0bcf4 .icon-b141a658{position:absolute}.TRouteMetaItem-91b0bcf4 .text-b07624ea{display:inline-block;margin-left:18px}\n", ""]);

// Exports
exports.locals = {
	"TRouteMeta": "TRouteMeta-ab9011f9",
	"TRouteMetaItem": "TRouteMetaItem-91b0bcf4",
	"clickable": "clickable-8d193461",
	"container": "container-c8a4422f",
	"icon": "icon-b141a658",
	"text": "text-b07624ea"
};